import {Injectable, InjectionToken} from '@angular/core';

export const STORAGE_TOKEN = new InjectionToken<Storage>('StorageToken');

export abstract class UIStorageService {
  public abstract set(key: string, value: any): void;
  public abstract get(key: string): string;
  public abstract remove(key: string): void;
}

@Injectable({
  providedIn: 'root'
})
export class UILocalStorageService {
  public set(key: string, value: any) {
    localStorage.setItem(key, value);
  }

  public get(key: string) {
    return localStorage.getItem(key) ?? '';
  }

  public remove(key: string) {
    localStorage.removeItem(key);
  }
}
